import { useContext } from 'react';
import { BreakpointContext } from 'contexts/breakpoint/BreakpointContext';
import { CtaDropdownDesktop } from './CtaDropdownDesktop';
import { CtaDropdownProps } from './CtaDropdown.types';
import { CtaDropdownMobile } from './CtaDropdownMobile';

export const CtaDropdown: React.FC<CtaDropdownProps> = (props) => {
  const bp = useContext(BreakpointContext);
  const isMobile = bp === 'xs' || bp === 'sm';

  if (isMobile) {
    return <CtaDropdownMobile {...props} />;
  }
  return <CtaDropdownDesktop {...props} />;
};
